import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { SnackbarProvider } from 'notistack';
import ClearIcon from '@material-ui/icons/Clear';

import './App.css';
import Routers from './routers';
import { getThemeMode } from './state/theme/theme.selector';
import './languages/index';
import { useStylesToast } from './constants/styles/Toast';
import { Notifiers } from './components';

function App() {
  const themeMode = useSelector(getThemeMode);
  const classes = useStylesToast();
  const notistackRef = React.createRef();

  const onClickDismiss = useCallback(
    (key) => () => {
      notistackRef.current.closeSnackbar(key);
    },
    [notistackRef],
  );

  return (
    <SnackbarProvider
        ref={notistackRef}
        hideIconVariant
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        classes={{
          variantSuccess: classes.success,
          variantError: classes.error,
          variantWarning: classes.warn,
        }}
        action={(key) => (
          <ClearIcon
            onClick={onClickDismiss(key)}
          />
        )}
      >
      <ThemeProvider theme={{ mode: themeMode }}>
        <Notifiers />
        <Routers />
      </ThemeProvider>
      </SnackbarProvider>
  );
}

export default App;
